let sortingActions = {
    applySorting: function(data) {
        return (dispatch, getState)=>{
            return new Promise((resolve, reject)=>{
                let currentData = getState().searchSort;
                const merged = {...currentData, ...data};
                dispatch({ type:'APPLY_SORTING', data:merged});
                resolve(merged);
            });
        };
    }
};

export default sortingActions;
